<template>
    <div class="bg_main">
        <v-row>
            <v-col cols="12">
                <v-card v-if="proceduresStore.procedureDataForm ">
                    <v-container>
                        <v-card-title  class="font-weight-black mobile-padding-bottom" style="color:#ff8400">
                        <!-- {{proceduresStore.taskSteps[currentIndexForm].formulario_nombre}} -->
                        {{processStore.processName}} 
                        </v-card-title>
                        <!-- <v-card-subtitle >
                        {{processStore.processName}} 
                        </v-card-subtitle> -->
                    </v-container>
                    <v-container>
                        <!-- STEPPER ON HEADER -->
                        <TaskSteps :current-task="getCurrentStep()" :tramite_id="procedureMeta.tramite_id"/>

                        <!-- FORM CONTENT -->
                        <Form procedure-action="create"/>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex";
    import {procedureCreateRequest, procedureTaskStepsRequest} from "bestgob-core/api/models";

    import Form from '../components/Procedure/Form'
    import TaskSteps from '../components/Procedure/TaskSteps'

    export default {
        data(){
          return {
              currentTask: 1,
              currentIndexForm: 0

          }
        },
        components: {
            Form, TaskSteps
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures, processStore: state => state.processes}),
            ...mapGetters('procedures', ['procedureMeta'])
        },

        created() {
            //VueX call
            this.clearProcedureForm()
            this.processStore.processName = null

            this.$gtag.event('crear', { method: 'Google' })
        },

        mounted() {
            let routeName = this.$route.name

            //Sart new procedure
            if (routeName === 'procedure_create'){
                this.$gtag.event('tramite_crear', { method: 'Google' }) // Google Analytics
                this.initProcedureCreation()
            } // Continue procedure
            else if (routeName === 'procedure_continue'){
                this.$gtag.event('tramite_continuar', { method: 'Google' }) // Google Analytics
                this.initProcedureContinue()
            }// Continue procedure
            else if (routeName === 'procedure_view'){
                this.$gtag.event('tramite_Ver', { method: 'Google' }) // Google Analytics
                this.initProcedureView()
            }
        },

        updated() {
            this.$nextTick(() => {
                if (this.proceduresStore.procedureDataForm != null){
                    if (this.processStore.processName == null){
                        this.fetchProcessName()
                    }else if (this.proceduresStore.taskSteps == null){
                        this.fetchTaskSteps()
                    }
                }
            })
        },

        methods: {
            ...mapActions('procedures', [
                'createProcedure', 'getProcedureTaskSteps', 'continueProcedure',
                'viewProcedure', 'clearProcedureForm'
            ]),
            ...mapActions('processes', ['getProcessDetails']),

            initProcedureCreation(){
                let request = procedureCreateRequest()
                request.processId = this.$route.params.processId

                //Call from VueX
                this.createProcedure(request)
            },

            initProcedureContinue(){
                //Call from VueX
                this.continueProcedure(this.$route.params.stageId)
            },

            initProcedureView(){
                //Call from VueX
                this.viewProcedure(this.$route.params.stageId)
            },

            fetchProcessName(){
                //Call from Vuex: Get process details
                this.getProcessDetails(this.procedureMeta.proceso_id)
            },

            fetchTaskSteps(){
                let request = procedureTaskStepsRequest()
                request.stageId = this.procedureMeta.etapa_id
                request.taskId = this.procedureMeta.tarea_id

                //Call from VueX: get task steps to show on Header
                this.getProcedureTaskSteps(request)
            },

            getCurrentStep(){
                let currentIndex = 0
                if (this.proceduresStore.taskSteps != null){
                    this.proceduresStore.taskSteps.forEach((step, index) => {
                        if (step.formulario_id == this.procedureMeta.formulario_id){
                            currentIndex = (index + 1)
                            return
                        }
                    })
                }
                if (currentIndex == 0 && this.proceduresStore.procedureDataForm.next_url != null ){
                    // currentIndex = this.proceduresStore.taskSteps.length + 1
                }
                this.currentIndexForm = currentIndex-1
                return currentIndex
            }

        }
    };
</script>

<style >


input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

   

    .montserrat{
        font-family: "Montserrat" !important;
    }

    .v-application.fondo_login fieldset{
        border-bottom: 0px !important
    }
    .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        /* min-height: unset !important; */
    }

    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
    }

    .v-text-field--focused{
        transition: unset !important;   
    }

    .aux-codigo   .v-input .v-input__control  .v-input__slot{
        border: unset;
        min-height: 2rem !important;
    }
    .aux-codigo   .v-input .v-input__control  .v-input__slot .v-text-field__slot input{
       height: 2rem  !important;
       max-height: 2rem !important;
    }
    .v-input--selection-controls .v-input__slot{
        border: unset !important
    }
    .v-select__slot {
        height: 2rem !important;
    }
    .v-text-field--enclosed .v-input__prepend-outer{
        /* margin-top: 1rem !important; */
        display: none;
    }
    .v-file-input .v-file-input__text .v-chip{
        margin-top: -.5%;
        margin-bottom: -.5%;
    }
    .theme--light.v-file-input .v-file-input__text--placeholder{
        margin-top: -.5%;
        bottom-top: -.5%;
    }
    .v-application--is-ltr .v-text-field .v-input__append-inner{
        margin-top: 1% !important;
    }
    .title-tramite{
        color: #ff8400 !important;
    }
    
@media only screen and (max-width: 1000px){
    .mobile-padding-bottom{
        padding-bottom: 1rem;
    }
}
</style>
